<template>
  <v-dialog v-model="dialog" max-width="900" scrollable @click:outside="$emit('update:activated', false)">
    <v-card>
      <v-card-title class="headline">Selecionar Simulação de Baixas:</v-card-title>
      <v-row class="mx-auto" no-gutters>
        <v-col cols="12">
          <v-text-field
            v-show="!loading"
            v-model="search"
            append-icon="mdi-magnify"
            class="mx-10 py-4"
            label="Procurar"
            hide-details
            single-line
          />
        </v-col>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="items"
            :items-per-page="itemsPerPage"
            :search.sync="search"
            :page.sync="currentPage"
            :loading="loading"
            :hide-default-header="loading"
            :hide-default-footer="loading"
            no-data-text="Nenhuma simulação de baixas disponível"
            :mobile-breakpoint="0"
          >
            <template v-slot:item="row">
              <tr @click="selecionarItem(row.item)">
                <td class="button cursor-pointer">
                  {{ row.item.id }}
                </td>
                <td class="button cursor-pointer" style="max-width: 400px">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div class="text-truncate" v-bind="attrs" v-on="on">
                        {{ row.item.nome }}
                      </div>
                    </template>
                    <span>{{ row.item.nome }}</span>
                  </v-tooltip>
                </td>
                <td class="button cursor-pointer">
                  {{ row.item.data_base | formatToMonth }}
                </td>
                <td class="button cursor-pointer">
                  {{ row.item.data_processamento | parseToDateTimeBR }}
                </td>
                <td class="button cursor-pointer">
                  {{ row.item.usuario.nome }}
                </td>
              </tr>
            </template>
            <template v-slot:[`footer.page-text`]>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="primary" v-bind="attrs" v-on="on" @click="getData()">mdi-refresh</v-icon>
                </template>
                <span>Clique aqui para recarregar as simulações de baixas</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
  import SimulacaoBaixasService from '@/services/SimulacaoBaixasService';

  export default {
    props: {
      activated: {
        type: Boolean,
        required: true
      },
      origem: {
        type: String,
        default: ''
      },
      dataBase: {
        type: String,
        required: false,
        default: null
      }
    },

    emits: ['update:activated', 'selected'],

    data: () => ({
      currentPage: 1,
      itemsPerPage: 5,
      search: undefined,
      items: [],
      loading: false,
      headers: [
        {
          text: '#',
          value: 'id'
        },
        {
          text: 'Nome',
          value: 'nome'
        },
        {
          text: 'Data Base',
          value: 'data_base'
        },
        {
          text: 'Executado',
          value: 'data_processamento'
        },
        {
          text: 'Usuário',
          value: 'usuario'
        }
      ]
    }),

    computed: {
      dialog() {
        return this.activated;
      }
    },

    mounted() {
      this.getData();
    },

    methods: {
      getData() {
        this.loading = true;

        SimulacaoBaixasService.getByOrigemDataBase(this.origem, this.dataBase)
          .then((response) => (this.items = response.data.data))
          .catch(() =>
            this.$toast.error('Erro ao recuperar as Simulações de Baixas.', '', {
              position: 'topRight'
            })
          )
          .finally(() => (this.loading = false));
      },

      selecionarItem(item) {
        const data = {
          id: item.id,
          nome: item.nome
        };

        this.$emit('selected', data);

        setTimeout(() => {
          this.search = '';
        }, 500);
      }
    },

    watch: {
      search() {
        this.currentPage = 1;
      },
      dataBase() {
        this.getData();
      }
    }
  };
</script>

<style>
  .b-valid-label {
    color: #003a63;
    font-weight: 400;
  }
</style>
